import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-aq-onefive-onesix',
  templateUrl: './aq-onefive-onesix.component.html',
  styleUrls: ['./aq-onefive-onesix.component.scss']
})
export class AqOnefiveOnesixComponent implements OnInit {
  src: string ='assets/pdf/2015_16.pdf';
  constructor() { }

  ngOnInit(): void {
  }

}
